import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable, catchError, from, switchMap } from 'rxjs';

import { AuthenticationService } from '../services/authentication.service';
import { environment } from '../../environments/environment';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private authenticationService: AuthenticationService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    // add auth header with jwt if user is logged in and request is to api url
    const user = this.authenticationService.userValue;
    if (user) {
      return from(this.authenticationService.getToken()).pipe(
        switchMap((token) => {
          const user = this.authenticationService.userValue;
          const isLoggedIn = user && token;
          const isApiUrl = request.url.startsWith(environment.apiUrl);
          if (isLoggedIn && isApiUrl) {
            console.log('token', token);
            request = request.clone({
              setHeaders: {
                Authorization: `Bearer ${token}`,
              },
            });
          }

          return next.handle(request);
        }),
        catchError((error) => {
          // Log the error or handle it as needed
          console.error('Token retrieval failed', error);
          // Proceed with the request without an Authorization header
          return next.handle(request);
        }),
      );
    } else {
      return next.handle(request);
    }
  }
}
